import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import { HeroEntry } from "../types/heroes";
import { castleKeys } from "./castle";

export const heroKeys = {
  list: ["heroes"] as const,
};

export function useHeroes() {
  return useQuery({
    queryKey: heroKeys.list,
    queryFn: async () => {
      const res = await api.get<HeroEntry[]>("/heroes");
      return res.data;
    },
    refetchInterval: 10_000,
    staleTime: 3000,
  });
}

function makeHeroMutation(endpoint: string) {
  return function useHeroAction() {
    const qc = useQueryClient();
    return useMutation({
      mutationFn: async (heroId: string) => {
        const res = await api.post(endpoint, { heroId });
        return res.data;
      },
      onSuccess: () => {
        qc.invalidateQueries({ queryKey: heroKeys.list });
        qc.invalidateQueries({ queryKey: castleKeys.state });
      },
    });
  };
}

export const useRecruitHero = makeHeroMutation("/heroes/recruit");
export const useLevelUpHero = makeHeroMutation("/heroes/upgrade-level");
export const useStarUpHero = makeHeroMutation("/heroes/upgrade-stars");
